import React from "react";
import { Route, Routes } from "react-router-dom";
import "./App.css";
import BookGrid from "./components/BookGrid/BookGrid";
import Navbar from "./components/shared/Navbar";
import Add from "./pages/Add";
import Edit from "./pages/Edit";
import Home from "./pages/Home";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

function App() {
  return (
    <div>
      <Navbar />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/add" element={<Add />} />
        <Route path="/edit/video/:bookId" element={<Edit />} />
      </Routes>

      {/* toast container */}
      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="dark"
      />
      {/* *********** */}
    </div>
  );
}

export default App;
